import {useCallback, useEffect, useState} from 'react';
import {UseFormGetValues} from 'react-hook-form';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {useFAContext} from 'src/components/providers/facebookAds';
import {IBusinessDetails} from 'src/types/common/BusinessDetails';
import {IGradeProcess} from 'src/types/google/GoogleProcess';
import {postFacebookProcess} from 'src/utils/helpers';
import {Logger} from 'src/utils/Logger';

export interface IFormStepTwo {
  businessName: string;
  website: string;
  categoryId: string;
  subcategoryId: string;
}

const FormStepTwoFields = [
  'businessName',
  'website',
  'categoryId',
  'subCategoryId'
];

type ReturnType = {
  disabled: boolean;
  onSubmit: () => void;
}

export const useSubmitForm = (getValues: UseFormGetValues<IFormStepTwo>): ReturnType => {
  const [disabled, setDisabled] = useState(false);
  const [reportID, setReportID] = useState<string | null>(null);
  const navigate = useNavigate();
  const context = useFAContext();
  const [searchParams] = useSearchParams();
  const cid = searchParams.get('cid');

  const onSubmit = useCallback(() => {
    setDisabled(true);

    const businessDetails = FormStepTwoFields.reduce(
      (result, fieldName) => ({
        ...result,
        [fieldName]: getValues(fieldName as keyof IFormStepTwo)
      }),
      {}
    ) as IBusinessDetails;

    Logger.trace('onSubmit:businessDetails', {businessDetails}, 'FormStepTwo');
    context.setBusinessDetails({...businessDetails});

    postFacebookProcess({
      auth: context.auth!,
      accountId: context.facebookAdsAccount.accountId!,
      ...context.userDetails,
      ...businessDetails
    })
      .then((response: IGradeProcess) => {
        Logger.success('onSubmit:FacebookProcess:success', {response}, 'FormStepTwo');
        setReportID(response.uuid);
      });
  }, [context, getValues]);

  useEffect(() => {
    Logger.trace('useEffect:reportID', {reportID}, 'FormStepTwo');

    if (reportID) {
      if (cid) navigate(`/facebook-grader/report/${reportID}?cid=${cid}`);
      else navigate(`/facebook-grader/report/${reportID}`);
    }
  }, [reportID]);

  return {disabled, onSubmit};
};
